/* Immershop CRO: light, one-time purchase CTA acknowledgement. */
(() => {
  const selector = '.product-form__submit.button';
  const pulse = (button, key) => {
    if (!button || button.disabled || button.dataset[key] === 'true') return;
    button.dataset[key] = 'true';
    button.classList.remove('imr-cro-cta-entered');
    window.requestAnimationFrame(() => button.classList.add('imr-cro-cta-entered'));
    window.setTimeout(() => button.classList.remove('imr-cro-cta-entered'), 800);
  };
  const observePurchaseCtas = () => {
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        pulse(entry.target, 'imrCroViewportPulsed');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.55 });
    document.querySelectorAll(selector).forEach((button) => observer.observe(button));
  };
  document.addEventListener('change', (event) => {
    if (!event.target.closest('.product-form__input')) return;
    const submit = event.target.closest('form')?.querySelector(selector);
    window.requestAnimationFrame(() => pulse(submit, 'imrCroVariantPulsed'));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observePurchaseCtas, { once: true });
  else observePurchaseCtas();
})();
